import React from 'react'
import './SearchInputBox.scss'
import { ReactComponent as SearchIcon } from '../assets/svg/leftBar/search.svg'
import { ReactComponent as TrashbinIcon } from '../assets/svg/leftBar/trashbin.svg'

function SearchInputBox({index, searchValue, setSearchValue, singleSearch, setLoading, setFilterLoading, enable}) {
    let tempSearchValue = [...searchValue]
    return (
        <div className='SearchInputBox'>
            <input type="text" name={index} value={searchValue[index]?.value || ''} disabled={!enable}
            onChange={(e) => {
                tempSearchValue[index].value = e.target.value
                setSearchValue(tempSearchValue)
            }}
            onKeyPress={(e) =>
                e.key === 'Enter' && singleSearch(index)
            }/>
            <div className="right">
            <SearchIcon onClick={() => { singleSearch(index) }}/>
            <TrashbinIcon
                onClick={() => {
                    let tempSearchValue = [...searchValue]
                    tempSearchValue[index].value = null
                    setSearchValue(tempSearchValue)
                    // setProgrammiDispData([])
                    setLoading(false)
                    setFilterLoading(false)
                }}
            />
            </div>
        </div>
    )
}

export default SearchInputBox